import { RESET_INPUT_24 } from "~/util/sds-compatible-icons";
import createSDSIcon from "~/ui/icon";
import { node } from "~/util/dom";
import Tooltip, { ETooltipFlow, ETooltipPosition } from "~/ui/tooltip";
import { _ } from "~/i18n";

const MIN_VALUE = 1;
const MAX_VALUE = 999;

export function roundToTwoDecimals(number: number) {
	return Math.round(number * 100) / 100;
}

export function createEditContainer(value, defaultValue, unit, resetCallback?: () => void) {
	const container = node("div");
	const input = node("input", {
		type: "number",
		min: MIN_VALUE.toString(),
		max: MAX_VALUE.toString(),
		step: "0.01",
		value: value ? roundToTwoDecimals(value).toString() : value,
		inputMode: "numeric",
	});
	const reset = createSDSIcon({
		symbol: RESET_INPUT_24,
	});

	const tooltip = new Tooltip({
		anchor: reset,
		trigger: reset,
		content: node("p", { innerHTML: _("reset") }),
		arrow: false,
		flow: ETooltipFlow.CENTER,
		position: ETooltipPosition.TOP,
		offset: [2, 0, 0, 0],
		hideTimeout: 0,
	});

	input.addEventListener("input", () => {
		if (input.value) {
			if (parseFloat(input.value) > MAX_VALUE) {
				input.value = MAX_VALUE.toString();
			} else if (parseFloat(input.value) < MIN_VALUE) {
				input.value = MIN_VALUE.toString();
			}
		}
	});

	reset.classList.add("hide");
	reset.addEventListener("click", () => {
		input.value = defaultValue;

		tooltip.hide();

		resetCallback && resetCallback();
	});

	container.append(
		input,
		node("span", {}, unit),
	);

	return {
		container,
		input,
		reset,
		tooltip,
	};
}
